import "./index.scss"
import "./Why2.scss"
import "./Process2.scss"
import "./Bmzx.scss"



/** WEBPACK FOOTER **
 ** ./src/ZhiXue/index.js
 **/